import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueMoment from 'vue-moment'
import VueNotification from 'vue-notification'
import VueProgressBar from 'vue-progressbar'
import VueSweetAlert2 from 'vue-sweetalert2'

import './styles/app.scss'
import 'bootstrap-vue/src/index.scss';

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.use(VueNotification)
Vue.use(VueProgressBar, { color: '#ffb300', thickness: '3px' })
Vue.use(VueSweetAlert2)

library.add(far, fal)
Vue.component('font-awesome-icon', FontAwesomeIcon)

export default new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    router.beforeEach((to, from, next) => {
      this.$Progress.start()
      next()
    })

    router.afterEach(() => {
      this.$Progress.finish()
    })
  }
}).$mount('#app')
